<template>
  <div class="home">
     <router-link class="back" to="/home">返回首页</router-link>
  </div>
</template>

<script>
export default {
  name: 'goHome'
}
</script>

<style lang="less" scoped>
.back {
  border: 0.01rem solid #4a90e2;
  text-align: center;
  line-height: 0.68rem;
  display: block;
  margin: 0.3rem auto 0;
  width: 2.1rem;
  height: 0.68rem;
  background: rgba(255, 255, 255, 1);
  color: #4a90e2;
  font-size: @fz24;
}
</style>
